import React from "react";
import IMG from "../../../constants/image";
import ImageBasic from "../../Common/Image/ImageBasic";
import {text} from "../../../constants/text";
import {Link} from "react-router-dom";

const PostOfficeNotification = () => (
    <div className="md:flex justify-center p-3 rounded-md bg-[#FFFCF3] text-xs md:space-x-4">
        <div className='flex items-center space-x-2 mb-2 md:mb-0'>
            <ImageBasic className='w-6 h-6' src={IMG.icon.errorOutlineGray} alt='icon error'/>
            <div className="text-gray-600 max-w-[380px]">
                {text.confirmPackageAndDropOffInstructions}
            </div>
        </div>
        <Link
            to={''}
            className="ml-8 md:ml-0 text-green-600 whitespace-nowrap underline">{text.viewPostOfficeList}</Link>
    </div>
);
export default PostOfficeNotification;